// Configs de pestañas de sección (para <SectionTabs>). Recursos afines agrupados bajo
// una misma sección del menú: Semen/ASOCEBU/Razas bajo Animales; Embriones/Laboratorios
// bajo Sesiones OPU; Fincas bajo Clientes; Tareas/Partos/Planear OPU bajo Planeación.

export const ANIMAL_TABS = [
    { label: 'Donadoras',  to: '/admin/animals' },
    { label: 'Receptoras', to: '/admin/recipients' },
    { label: 'Toros',      to: '/admin/toros' },
    { label: 'Semen',      to: '/admin/semen' },
    { label: 'ASOCEBU',    to: '/admin/asocebu' },
    { label: 'Razas',      to: '/admin/races' },
];

export const OPU_TABS = [
    { label: 'Sesiones OPU',       to: '/admin/opu' },
    { label: 'Banco de embriones', to: '/admin/embryos' },
    { label: 'Laboratorios',       to: '/admin/labs' },
];

export const CLIENT_TABS = [
    { label: 'Clientes', to: '/admin/clients' },
    { label: 'Fincas',   to: '/admin/farms' },
];

export const PLANNING_TABS = [
    { label: 'Resumen',     to: '/admin/tasks' },
    { label: 'Dx',          to: '/admin/planning/dx' },
    { label: 'Partos',      to: '/admin/planning' },
    { label: 'Planear OPU', to: '/admin/opu-planning' },
];

// Servicios agrupa mensajería y (a futuro) comunicados/programador de tareas.
export const SERVICE_TABS = [
    { label: 'Notificaciones', to: '/admin/notifications' },
];

// Auditoría agrupa acciones administrativas sensibles. Por ahora Merges (unificar
// duplicados); a futuro se suman más acciones a la misma sección.
export const AUDIT_TABS = [
    { label: 'Merges',        to: '/admin/audit/merges' },
    { label: 'Eliminaciones', to: '/admin/audit/eliminaciones' },
];
